if (!customElements.get('multicolumn-component')) {
  customElements.define(
    'multicolumn-component',
    class MultiColumnComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          itemsWrapper: '.multicolumn__items-inner',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        this.items = parseInt(this.dataset.items || '4');
        this.tabletItems = parseInt(this.dataset.tabletItems || '3');
        this.mobileItems = parseInt(this.dataset.mobileItems || '2');
        this.sliderInstance = false;
        this.enableSwipeMobile = this.classList.contains('swipe-mobile');

        if (!this.enableSlider && !this.enableSliderMobile && !this.enableSwipeMobile) return;

        this.setupViewportListeners();
        this.init();
      }

      isMobile() {
        return window.innerWidth <= 767;
      }

      isTablet() {
        return window.innerWidth <= 1023;
      }

      setupViewportListeners() {
        this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');

        this.mobileMediaQuery.addEventListener('change', (e) => {
          this.handleViewportChange();
        });
      }

      init() {
        if (this.enableSlider) {
          this.initSlider();
          return;
        }

        if (this.isMobile() || this.isTablet()) {
          if (this.enableSliderMobile || this.enableSwipeMobile) {
            this.initSlider();
          }
        } else {
          this.destroySlider();
        }
      }

      handleViewportChange() {
        if (this.isMobile()) {
          if (this.enableSliderMobile || this.enableSwipeMobile) {
            this.initSlider();
          }
        } else {
          if (!this.enableSlider) {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        this.querySelector(this.selectors.itemsWrapper).classList.remove('f-flex', 'flex-nowrap');
        const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

        this.sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: columnGap.mobile,
          navigation: {
            nextEl: this.querySelector(this.selectors.nextEl),
            prevEl: this.querySelector(this.selectors.prevEl),
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
              spaceBetween: columnGap.tablet,
            },
            1024: {
              slidesPerView: this.items > 4 ? 4 : this.items,
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              slidesPerView: this.items,
              spaceBetween: columnGap.desktop,
            },
          },
          loop: false,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrapper, this.sliderOptions);
        this.sliderInstance.init();

        this.handleAccessibility();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.querySelector(this.selectors.itemsWrapper).classList.add('f-flex', 'flex-nowrap');
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', function () {
            const slide = element.closest('.swiper-slide');

            slide && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          }.bind(this));
        });
      }
    }
  );
}
